import Graph from "./graph-chart";
export default Graph;